/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Add_User_TitleInputs */



/**
* | output |
* | --- |
* | "Add New User" |
*
* @param {Team_Manager_Add_User_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_add_user_title = /** @type {((inputs?: Team_Manager_Add_User_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Add_User_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un nouvel utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuen Benutzer hinzufügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi nuovo utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить нового пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar nuevo usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("添加新用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいユーザーを追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई उपयोगकर्ता को जोड़ना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar novo usuário")
	return /** @type {LocalizedString} */ ("Add New User")
});